<div class="data-picker-header-container">
  <button mat-icon-button (click)="previousClicked('year')">
    <mat-icon>first_page</mat-icon>
  </button>

  <button mat-icon-button (click)="previousClicked('month')">
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>

  <div class="data-picker-label">{{periodLabel}}</div>

  <button mat-icon-button (click)="nextClicked('month')">
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
  <button mat-icon-button (click)="nextClicked('year')">
    <mat-icon>last_page</mat-icon>
  </button>
</div>


